import {
	SET_TIMESLOT_RULES,
	SAVE_TIMESLOT_RULES,
	SAVE_TIMESLOT_RULES_BULK,
	SAVE_TIMESLOTS,
} from './types';

// --- Rules (binding par section/produit) ---
// type : 'product' | 'section'
// rules : [{ idTimeslot, rule }]  (rule = 'enable' | 'disable')

// Met à jour les rules de la section/produit dans le store (merge)
export const setTimeslotRules = ({ type, id, rules }) => ({
	type: SET_TIMESLOT_RULES,
	entityType: type,
	id,
	rules,
});

// Déclenche la sauvegarde : la saga met à jour le store puis POST la totalité des rules
export const saveTimeslotRules = ({ type, id, rules }) => ({
	type: SAVE_TIMESLOT_RULES,
	entityType: type,
	id,
	rules,
});

// Déclenche la sauvegarde groupée : applique `rules` à chaque produit de `ids`
// (merge en une passe puis un seul POST de la totalité des rules).
export const saveTimeslotRulesBulk = ({ ids, rules }) => ({
	type: SAVE_TIMESLOT_RULES_BULK,
	ids,
	rules,
});

// --- Réglage global (enabled + CRUD des timeslots) ---

// déclenche la sauvegarde des timeslots (POST /timeslot + /timeslot/enabled + purge des
// rules orphelines). Le draft (enabled + timeslots) est édité localement dans le composant
// et transmis ici : le store n'est mis à jour qu'à la sauvegarde.
export const saveTimeslots = ({ enabled, timeslotPos, timeslots }) => ({
	type: SAVE_TIMESLOTS,
	enabled,
	timeslotPos,
	timeslots,
});
